import { Component, Input, OnInit } from '@angular/core';
import { Card } from '../../../card-container/card/card';
import { UserService } from '../../../../../shared-components/user/user.service';
import { LoginService } from '../../../../../shared-modules/login/login.service';
import { MatDialog } from '@angular/material/dialog';
import { YearService } from '../../../../../shared-components/year/year.service';
import { StudentService } from '../../../../../shared-components/student/student.service';
import { StudentSummaryService } from '../../../student-summary.service';
import { NavigationExtras, Router } from '@angular/router';
import { interval } from 'rxjs';
import * as moment from 'moment';
import * as _ from 'lodash';
import { EventDetailsModalComponent } from './event-details-modal/event-details-modal.component';

@Component({
    selector: 'app-calendar-card',
    templateUrl: './calendar-card.component.html',
    styleUrls: ['./calendar-card.component.css']
})
export class CalendarCardComponent implements OnInit {
    @Input() data: any;
    card: Card;
    v10: boolean;
    nonAttendanceDates: string[];
    eventDates: string[];
    startDate: string;
    endDate: string;

    constructor(private userService: UserService, private loginService: LoginService, private dialog: MatDialog, private yearService: YearService, private studentService: StudentService, private studentSummaryService: StudentSummaryService, private router: Router) {
    }

    ngOnInit() {
        this.v10 = this.loginService.LoginSettings.V10;
        this.card = this.data;
        if (this.card.display != 'Off') {
            const schoolIdStream = interval(100).subscribe(x => {
                if (this.studentService.studentEnrollment !== undefined) {
                    this.getStudentCalendar();
                    schoolIdStream.unsubscribe();
                }
            });
        }
    }

    getStudentCalendar() {
        const schoolId = this.studentService.studentEnrollment != null ? this.studentService.studentEnrollment.SchoolId : 0;
        // If undefined, set dates to the start and end of the current month
        if (!this.startDate && !this.endDate) {
            this.startDate = moment().startOf('month').format('MM/DD/YYYY');
            this.endDate = moment().endOf('month').format('MM/DD/YYYY');
        }
        this.studentSummaryService.getCardStudentCalendar(this.studentService.selectedStudent.Id, schoolId, this.yearService.student360Year.AYIdentifier, this.startDate, this.endDate, this.userService.userType, this.yearService.student360Year.Id).subscribe(response => {
            if (response.ok) {
                const possibleDates = [];
                const start = moment(this.startDate);
                const end = moment(this.endDate);
                const totalRequestedDays = end.diff(start, 'days') + 1;
                const cDate = _.cloneDeep(start);
                for (let i = 0; i < totalRequestedDays; i++) {
                    possibleDates.push(moment(cDate).format('MM/DD/YYYY'));
                    cDate.add(1, 'days');
                }
                if (response.body.length > 0) {
                    // clean up the dates
                    response.body.forEach(d => {
                        d.Date = moment(d.Date, 'M/D/YYYY H:mm:SS A').format('MM/DD/YYYY');
                    });
                    // Verify each date exists in the return set, if not add it as a non school day
                    const rDates = response.body.map(d => d.Date);
                    possibleDates.forEach(d => {
                        if (!rDates.includes(d)) {
                            response.body.push({
                                Date: d,
                                HasEvent: false,
                                HasSchool: false
                            });
                        }
                    });
                } else {
                    // Because the response was empty we can assume there is no school for the selected range
                    possibleDates.forEach(d => {
                        response.body.push({
                            Date: d,
                            HasEvent: false,
                            HasSchool: false
                        });
                    });
                }
                // Reset the data sources (because they are input parameters)
                this.eventDates = response.body.filter(d => d.HasEvent == true).map(d => d.Date);
                this.nonAttendanceDates = response.body.filter(d => d.HasSchool == false).map(d => d.Date);
            }
        });
    }

    monthChange(event: any) {
        this.startDate = moment(event, 'MM/DD/YYYY').startOf('month').format('MM/DD/YYYY');
        this.endDate = moment(event, 'MM/DD/YYYY').endOf('month').format('MM/DD/YYYY');
        this.getStudentCalendar();
    }

    calendarClick() {
        const navigationExtras: NavigationExtras = {
            // needs to be lower case view, day, week, month
            queryParams: {
                'selectedView': 'month',
                'selectedDate': this.endDate
            }
        };
        this.router.navigate(['/student360/calendar'], navigationExtras);
    }

    dayClick(calendarDay) {
        if (calendarDay.hasEvents) {
            const schoolId = this.studentService.studentEnrollment != null ? this.studentService.studentEnrollment.SchoolId : 0;
            this.studentSummaryService.getEventForDateRange(this.studentService.selectedStudent.Id, schoolId, this.yearService.student360Year.AYIdentifier, calendarDay.date, calendarDay.date, this.userService.userType).subscribe((response) => {
                if (response.ok) {
                    // Open a modal displaying the event info
                    this.dialog.open(EventDetailsModalComponent, { disableClose: true, autoFocus: false, data: { events: response.body, date: calendarDay.date } });
                }
            });
        }
    }
}
